.loadingCell {
  padding: var(--via-space-200) var(--via-space-200);
}
